import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18nModule, TranslationService } from '@spartacus/core';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomLandingModule } from '../../custom-landing.module';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { ToastrService } from 'ngx-toastr';
import { NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { DateRangePickerI18nService } from 'src/app/shared/services/date-range-picker-i18n.service';
import { CustomAdapter, CustomDateParserFormatter } from 'src/app/shared/services/date-range-picker-i18n.service';
import { DateRangePickerComponent } from 'ngx-daterange';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';

@Component({
  selector: 'app-ships-rail-and-consignment-list',
  standalone: true,
  imports: [NgbDatepickerModule, CustomLandingModule, CommonModule, FormsModule, NgSelectModule, I18nModule, SharedModule, InfiniteScrollDirective],
  templateUrl: './ships-rail-and-consignment-list.component.html',
  styleUrl: './ships-rail-and-consignment-list.component.scss',
  providers: [
    { provide: NgbDatepickerI18n, useClass: DateRangePickerI18nService },
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]

})
export class ShipsRailAndConsignmentListComponent implements OnInit {
  @ViewChild('dateRangePicker', { static: true })
  dateRangePicker: DateRangePickerComponent;
  title: any = '';
  navigationData: string = '';
   pageDetail: string = '';
  searchText = null;
  listSrc = '/images/list-view-orange.svg';
  gridSrc = '/images/grid-view.svg';
  list = true;
  grid = false;
  showClear = false;
  activeTab = 'inprogress';
  railList: any = [];
  shipConsignList: any = [];
  hoveredDate: NgbDate | null = null;
  startDate: NgbDate | null = null;
  endDate: NgbDate | null = null;
  nextMonth: string;
  preMonth: string;
  selectMonth: string;
  sidebar: boolean;
  railId: number;
  shipConsignId: number;
  display: any;
  selectYear: string;
  enableLoader: boolean ;
  page = 0;
  reachedToEnd: boolean = false;
  loadingData = false;
  selectedStatus: any;
  selectedSort:any='ETAD';
  shipmentTab: any;
  StatusList: any;
  selectedsortfilter:any='DESC';
  statuslength = 0;
  checkedstatusform: UntypedFormGroup;
  selectedSortConsign:any='DESC';
  fromDetails:any;
  sortOptions=[
     {id:'ETAD',code:'DESC',label:'ETAD (newest first) - Default'},
    {id:'ETAD',code:'ASC',label:'ETAD (oldest first)'},
    {id:'ETDS',code:'DESC',label:'ETDS (newest first)'},
    {id:'ETDS',code:'ASC',label:'ETDS (oldest first)'},
    {id:'ATDS',code:'DESC',label:'ATDS (newest first)'},
    {id:'ATDS',code:'ASC',label:'ATDS (oldest first)'}
  ]
  selectedSortValue=this.sortOptions[0];
  constructor(private route: ActivatedRoute,private cd: ChangeDetectorRef,private fb: UntypedFormBuilder,
    public formatter: NgbDateParserFormatter, private router: Router,
    private toastrService: ToastrService, private customProfileService: CustomProfileService, private translation: TranslationService) {
   this.checkedstatusform = this.fb.group({
      checkArray: this.fb.array([])
    });
    }
  ngOnInit(): void {
         this.filter()
        this.sidebar = true;
    if (this.router.url == '/shipment/rails'||this.router.url == '/shipment/rails?from=details') {
      this.display = "shipmentRail";
      this.getRailList();
      this.masterdata();
      this.translation
        .translate('breadcrumb.rails.pageTitle')
        .subscribe(res => {
          this.title = res;
        });
      this.translation
        .translate('breadcrumb.rails.breadcrumb')
        .subscribe(res => {
          this.navigationData = res;
        });
          this.translation
        .translate('breadcrumb.rails.pageDetail')
        .subscribe(res => {
          this.pageDetail = res;
        });

    }
    else if (this.router.url == '/shipment/shipconsignments'||this.router.url == '/shipment/shipconsignments?from=details') {
      this.display = "shipmentConsignment";
      this.getShipConsignList();

      this.translation
        .translate('breadcrumb.Shipconsign.pageTitle')
        .subscribe(res => {
          this.title = res;
        });
         this.translation
        .translate('breadcrumb.Shipconsign.pageDetail')
        .subscribe(res => {
          this.pageDetail = res;
        });
      this.translation
        .translate('breadcrumb.Shipconsign.breadcrumb')
        .subscribe(res => {
          this.navigationData = res;
        });

    }
    this.railId = 101;
    this.shipConsignId = 101
    console.log('display-->', this.display)
  }
  search() {
     this.searchText.toLowerCase();
    if (this.searchText.length >= 7) {
      // this.getShipmentdata();
      if(this.display === 'shipmentRail'){
        this.getRailList();
      }else if(this.display === 'shipmentConsignment'){
        this.getShipConsignList();
      }
    } else if (this.searchText.length == 0) {
      if(this.display === 'shipmentRail'){
        this.getRailList();
      }else if(this.display === 'shipmentConsignment'){
        this.getShipConsignList();
      }
    }
  }
  
  omitSpecialChar(event): any {
    console.log(event)
    if (this.searchText?.length >= 7) {
      this.showClear = false;
    }
    const k = event.charCode;
    if (k === 46) {
      return false;
    }
    // return this.isValidLetter(k);
  }
  filtersidebar() {
    this.sidebar = false;
  }
  selectChangeHandler(selected: any) {
    this.selectedSortConsign=selected;
    if (this.display === 'shipmentRail') {
      this.selectedSort = selected.id;
      this.selectedsortfilter = selected.code
      this.getRailList()
    }
    if (this.display === 'shipmentConsignment') {
      this.getShipConsignList()
    }

  }
  changeTab(data, showMsg?): any {
    this.activeTab = data;
    this.page = 0;
    this.reachedToEnd = false;
    if (data === 'inprogress') {
      // show completed tab
      this.shipmentTab = 'INPROGRESS';
    } else if (this.activeTab === 'completed') {
      // show completed tab
      this.activeTab = 'completed';
      this.shipmentTab = 'COMPLETED';
    }
    if (this.display === 'shipmentRail') {
      this.getRailList();
    } else if (this.display === 'shipmentConsignment') {
      this.getShipConsignList();

    }
  }
  masterdata() {
    let pageid = 'RAILCAR';
    let toastshown = false;
    this.customProfileService.getFiltersShipsDocsRails(pageid).subscribe((res) => {
      if (res) {
        this.StatusList = res.shipmentStatus;
      } (error) => {
        this.enableLoader = false;
        // this.toastrService.show('Something went wrong please contact support team.')
        this.translation.translate('shipment.erroroccuredmessage').subscribe(res => {
          if (!toastshown) {
            this.toastrService.show(res);
            toastshown = true
          }
        })
      }
    });

  }
    statusmobileFilter(e, id) {
      this.statuslength = 1;
      const checkArray: UntypedFormArray = this.checkedstatusform.get(
        'checkArray'
      ) as UntypedFormArray;
      if (e.target.checked) {
        checkArray.push(new UntypedFormControl(e.target.value));
      }
      else {
        let i = 0;
        checkArray.controls.forEach((item: UntypedFormControl) => {
          if (item.value === e.target.value) {
            checkArray.removeAt(i);
            return;
          }
          i++;
        });
        this.statuslength = 0;
      }
      this.selectedStatus = checkArray.value;
    }
   getResults(): any {
    this.closebar();
    this.filterData();
  }
  filter(){
      this.route.queryParams.subscribe(params=>{
      this.fromDetails=params['from']==='details';
     })
     if(!this.fromDetails){
      this.clearFilterData();
     }
     this.customProfileService.getsearch().subscribe((data)=>{
       if(data?.length){
         this.searchText = data;
       }
     })
     this.customProfileService.getstatus().subscribe((data)=>{
       if(data?.length){
         this.selectedStatus = data;
         this.changeStatus() 
       }
     })
    //  this.customProfileService.getendDate().subscribe((data)=>{
    //    if(data?.length){
    //      this.endDate = data;
    //    }
    //  })
    //  this.customProfileService.getstartDate().subscribe((data)=>{
    //    if(data?.length){
    //      this.startDate = data;
    //    }
    //  })
    this.customProfileService.getTemplateData().subscribe((tab) => {
      if (tab === 'inprogress') {
        this.shipmentTab = 'INPROGRESS';
        this.activeTab = 'inprogress';
      } else if (tab === 'completed') {
        this.activeTab = 'completed';
        this.shipmentTab = 'COMPLETED';
      }
    })

  }
  viewGrid() {

    if (this.router.url == '/shipment/rails'||this.router.url == '/shipment/rails?from=details') {
      this.getRailList();
      this.display = "shipmentRail";
    }
    else if (this.router.url == '/shipment/shipconsignments'||this.router.url == '/shipment/shipconsignments?from=details') {
      this.getShipConsignList();
      this.display = "shipmentConsignment";
    }
    this.gridSrc = '/images/grid-view-orange.svg';
    this.listSrc = '/images/list-view.svg';
    this.grid = true;
    this.list = false;
  }
  viewList() {
    if (this.router.url == '/shipment/rails'||this.router.url == '/shipment/rails?from=details') {
      this.getRailList();
      this.display = "shipmentRail";
    }
    else if (this.router.url == '/shipment/shipconsignments'||this.router.url == '/shipment/shipconsignments?from=details') {
      this.getShipConsignList();
      this.display = "shipmentConsignment";
    }

    this.listSrc = '/images/list-view-orange.svg';
    this.gridSrc = '/images/grid-view.svg';
    this.list = true;
    this.grid = false;
  }
  gotoDeatils(shipconsigndata) {
     if(this.activeTab === 'inprogress'){
      this.customProfileService.setTemplateData('inprogress');
    }else{
      this.customProfileService.setTemplateData('completed');  
    }
       this.customProfileService.setsearch(this.searchText);
      this.customProfileService.setstatus(this.selectedStatus);
      // this.customProfileService.setstartDate(this.startDate);
      // this.customProfileService.setendDate(this.endDate);
    if (this.router.url == '/shipment/rails'||this.router.url == '/shipment/rails?from=details') {
       let currTab;
      this.activeTab == 'inprogress' ? currTab = 'INPROGRESS' : currTab = 'COMPLETED';
    
    this.router.navigate(['/shipment/raildetails/' + shipconsigndata.railNumber],{
           state: {
             shipmentTab: currTab,
             scheduleQtyUnit:shipconsigndata.scheduledQuantityInSalesUnit,
             actualQtyUnit:shipconsigndata.actualQuantityInSalesUnit
           }
          })
    }
    else if (this.router.url == '/shipment/shipconsignments'||this.router.url == '/shipment/shipconsignments?from=details') {
      let currTab;
      this.activeTab == 'inprogress' ? currTab = 'INPROGRESS' : currTab = 'COMPLETED';
      this.router.navigate(['/shipment/shipconsigndetails/' + shipconsigndata.consignmentNumber], { queryParams: { shipmentTab: currTab } })

    }

  }
  getRailList() {
    this.enableLoader = true;
    this.page = 0
    const requestParams = {
      currentPage: this.page,
      shipmentTab: this.activeTab == 'inprogress' ? this.shipmentTab = 'INPROGRESS' : this.shipmentTab = 'COMPLETED',
      startDate:this.startDate ? this.startDate.year+'-'+this.startDate.month+'-'+this.startDate.day : '',
      endDate:this.endDate ?  this.endDate.year+'-'+this.endDate.month+'-'+this.endDate.day  : '',
      status: this.selectedStatus?.length ? this.selectedStatus : '',
      sortBy:this.selectedSort?this.selectedSort:'',
      sortFilter:this.selectedsortfilter?this.selectedsortfilter:'',
      searchText:this.searchText
    }
    this.customProfileService.getShipRailList(requestParams).subscribe((data) => {
      this.railList = data.railList;
            this.enableLoader = false;
            this.cd.detectChanges()
    }, err => {
      this.enableLoader = false;
      this.toastrService.show('Rail List is having some error')
    })

  }
  getShipConsignList() {
    this.enableLoader = true;
    const requestParams = {
    shipmentTab:this.activeTab == 'inprogress' ? this.shipmentTab = 'INPROGRESS' : this.shipmentTab = 'COMPLETED',
    startDate:this.startDate ? this.startDate.year+'-'+this.startDate.month+'-'+this.startDate.day : '',
    endDate:this.endDate ?  this.endDate.year+'-'+this.endDate.month+'-'+this.endDate.day  : '',
    searchText:this.searchText,
    sortBy:this.selectedSortConsign?this.selectedSortConsign:'',

    }
    this.customProfileService.getShipConsignmentList(requestParams).subscribe((data) => {
      this.enableLoader = false;
      this.shipConsignList = data.consignmentsList;
    }, err => {
      this.toastrService.show("Sorry something went wrong, please try again!")
      this.enableLoader = false;

    })
  }

  onDateSelection(date: any, datePicker) {
    this.showClear = true;
    if (!this.startDate && !this.endDate) {
      this.startDate = date;
    } else if (
      this.startDate &&
      !this.endDate &&
      date &&
      date.after(this.startDate)
    ) {
      this.endDate = date;
      //this.filterData();
      if (this.display === 'shipmentRail') {
        this.getRailList();

      } else if (this.display === 'shipmentConsignment') {
        this.getShipConsignList();

      }
    } else {
      this.endDate = null;
      this.startDate = date;

    }
  }

  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName(
      'btn btn-link ngb-dp-arrow-btn'
    );
    for (let i = 0; i < element3.length; i++) {
      let value = element3[i].getAttribute('title');
      console.log(value);
      element3[i].setAttribute('title', this.setTitle(value));
    }

    let element4 = document.getElementsByTagName(
      'ngb-datepicker-navigation-select'
    )[0].children;
    for (let i = 0; i < element4.length; i++) {
      let value = element4[i].getAttribute('title');
      element4[i].setAttribute('title', this.setTitle(value));
    }
  }
  setTitle(value) {
    switch (value) {
      case 'Select year':
        return this.selectYear;
      case 'Select month':
        return this.selectMonth;
      case 'Next month':
        return this.nextMonth;
      case 'Previous month':
        return this.preMonth;
      default:
        return;
    }
  }
  filterData() {
this.enableLoader = true;
    // this.getShipmentdata();
    if(this.display === 'shipmentRail'){
      this.getRailList();
    }else if(this.display === 'shipmentConsignment'){
      this.getShipConsignList();
    }
  }
  clearFilterData() {
    this.closebar();
    this.showClear = false;
    this.startDate = null;
    this.endDate = null;
    this.selectedStatus = [];
    this.searchText = null;
    this.customProfileService.resetTemplateData();
     this.customProfileService.resetsearchFilter();
     this.customProfileService.resetstatusFilter();
    //  this.customProfileService.resetstartDateFilter();
    //  this.customProfileService.resetendDateFilter();

    if(this.display === 'shipmentRail'){
      this.getRailList();
    }else if(this.display === 'shipmentConsignment'){
      this.getShipConsignList();
    }
  }
  closebar() {
    this.sidebar = true;
  }
  clearFilterMobile(){
      this.closebar();
    const checked = false;
    this.StatusList.forEach(item => (item.selected = checked));
    this.selectedStatus = [];
    this.searchText = null;
    this.startDate=null;
    this.endDate=null;
    // this.getShipmentdata();
    if(this.display === 'shipmentRail'){
      this.getRailList();
    }else if(this.display === 'shipmentConsignment'){
      this.getShipConsignList();
    }
  }
  changeStatus() {
  if((this.startDate==null ||this.startDate == undefined) &&
  (this.endDate==null ||this.endDate == undefined) &&
   (this.selectedStatus?.length == 0 ||this.selectedStatus?.length==undefined)){       
  this.showClear = false;
    } else {
      this.showClear = true;
    }
   this.reachedToEnd = false;
    this.getRailList();
  }

  isHovered(date: NgbDate) {
    return (
      this.startDate &&
      !this.endDate &&
      this.hoveredDate &&
      date.after(this.startDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return (
      this.endDate && date.after(this.startDate) && date.before(this.endDate)
    );
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.startDate) ||
      (this.endDate && date.equals(this.endDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }
  loadMoreData() {
    this.loadingData =true;
    this.page += 1
    if(this.display === 'shipmentRail'){
          const requestParams = {
      currentPage: this.page,
      shipmentTab: this.activeTab == 'inprogress' ? this.shipmentTab = 'INPROGRESS' : this.shipmentTab = 'COMPLETED',
      startDate:this.startDate ? this.startDate.year+'-'+this.startDate.month+'-'+this.startDate.day : '',
      endDate:this.endDate ?  this.endDate.year+'-'+this.endDate.month+'-'+this.endDate.day  : '',
      status: this.selectedStatus?.length ? this.selectedStatus : '',
      sortBy:this.selectedSort?this.selectedSort:'',
      sortFilter:this.selectedsortfilter?this.selectedsortfilter:'',
      searchText:this.searchText
    }
    this.customProfileService.getShipRailList(requestParams).subscribe((data) => {
      this.loadingData =false;
      if(data.railList?.length){
      this.railList = this.railList.concat(data.railList);
      this.enableLoader=false;
      }
      else{
           this.reachedToEnd = true;
           this.enableLoader = false
      }
      this.cd.detectChanges()
    }, err => {
      this.enableLoader = false;
      this.toastrService.show('Rail List is having some error')
    })
    }
    // else if(this.display === 'shipmentConsignment'){
    //       const requestParams = {
    // currentPage: this.page,
    // shipmentTab:this.activeTab == 'inprogress' ? this.shipmentTab = 'INPROGRESS' : this.shipmentTab = 'COMPLETED',
    // startDate:this.startDate ? this.startDate.year+'-'+this.startDate.month+'-'+this.startDate.day : '',
    // endDate:this.endDate ?  this.endDate.year+'-'+this.endDate.month+'-'+this.endDate.day  : '',
    // searchText:this.searchText,
    // sortBy:this.selectedSortConsign?this.selectedSortConsign:'',

    // }
    // this.customProfileService.getShipConsignmentList(requestParams).subscribe((data) => {
    //   this.loadingData =false;
    //   if(data.consignmentsList?.length){
    //   this.shipConsignList = this.shipConsignList.concat(data.consignmentsList);
    //   this.enableLoader=false;
    //   }
    //   else {
    //         this.reachedToEnd = true;
    //         this.enableLoader = false
    //       }
    // }, err => {
    //   this.toastrService.show("Sorry something went wrong, please try again!")
    //   this.enableLoader = false;

    // })

    // }
  }
  onScrollGrid(): any {
    if (!this.loadingData) {
      this.loadMoreData();
    }
  }
    downloadShipmentReport(reportType) {
    let toastshown = false;
    if (reportType === 'SHIPS_AND_DOCS_RAIL_DETAIL_REPORT') {
      this.enableLoader = true;
      this.customProfileService.exportReport(reportType, null,null,this.shipmentTab).subscribe(response => {
        if (response.status == 'success') {
          const ref = document.createElement("a");
          ref.href = `data:application/xlsx;base64,${response.code}`
          if(reportType === 'SHIPS_AND_DOCS_RAIL_DETAIL_REPORT'){
            ref.download = `ShipsAndDocsRailReport.xlsx`
          }
           ref.click();
          this.enableLoader = false;
          this.translation.translate('shipment.downloaddoc').subscribe(res=>{
            if(!toastshown){
              this.toastrService.show(res);
              toastshown=true;
            }
          })
        }
        else {
          this.enableLoader = false;
          this.toastrService.show(response.status);
        }
      }, err => {
        this.enableLoader = false;
        // this.toastrService.show('Download unsuccessful, please contact support team.');
        this.translation.translate('shipment.downloadunsuccess').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
          }
        })
      })
    }
    
  
  }

}
